import { Equipment } from '../../types';

export const mockEquipmentData: Equipment[] = [
  {
    id: '1',
    name: 'Commercial Treadmill Pro X1',
    category: 'Cardio',
    brand: 'TechnoGym',
    model: 'Artis Run',
    acquisitionDate: '2023-01-15',
    acquisitionCost: 8500,
    currentValue: 7200,
    status: 'Available',
    condition: 'Excellent',
    location: 'Cardio Zone A',
    maxUsers: 1,
    currentUsers: 0,
    maintenanceSchedule: 'Weekly',
    lastMaintenance: '2024-01-15',
    nextMaintenance: '2024-01-22',
    warrantyExpiry: '2026-01-15',
    notes: 'High-end commercial treadmill with touchscreen',
    utilization: 85,
    specifications: {
      weight: 180,
      dimensions: '200 x 90 x 160 cm',
      powerRequirement: '220V AC',
      capacity: '200kg max user weight',
    },
    attachments: ['manual.pdf', 'warranty.pdf'],
    qrCode: 'TG-TR-001',
    serialNumber: 'TG23450789',
  },
  {
    id: '2',
    name: 'Olympic Barbell Set',
    category: 'Strength',
    brand: 'Eleiko',
    model: 'Sport Training Bar',
    acquisitionDate: '2022-08-20',
    acquisitionCost: 450,
    currentValue: 380,
    status: 'Available',
    condition: 'Good',
    location: 'Free Weights Area',
    maxUsers: 2,
    currentUsers: 0,
    maintenanceSchedule: 'Monthly',
    lastMaintenance: '2024-01-10',
    nextMaintenance: '2024-02-10',
    warrantyExpiry: '2025-08-20',
    notes: 'Standard Olympic barbell with knurled grip',
    utilization: 92,
    specifications: {
      weight: 20,
      dimensions: '220 cm length',
      capacity: '700kg max load',
    },
    attachments: ['specifications.pdf'],
    qrCode: 'EL-BB-002',
    serialNumber: 'EL89234567',
  },
  {
    id: '3',
    name: 'Adjustable Dumbbell Set',
    category: 'Strength',
    brand: 'PowerBlock',
    model: 'Elite EXP',
    acquisitionDate: '2023-03-10',
    acquisitionCost: 800,
    currentValue: 720,
    status: 'In Use',
    condition: 'Excellent',
    location: 'Functional Training Area',
    maxUsers: 2,
    currentUsers: 1,
    maintenanceSchedule: 'Quarterly',
    lastMaintenance: '2023-12-15',
    nextMaintenance: '2024-03-15',
    warrantyExpiry: '2028-03-10',
    notes: 'Expandable from 5-90 lbs per dumbbell',
    utilization: 78,
    specifications: {
      weight: 90,
      dimensions: '32 x 17 x 17 cm per dumbbell',
      capacity: '90 lbs max per dumbbell',
    },
    attachments: ['manual.pdf', 'expansion_guide.pdf'],
    qrCode: 'PB-DB-003',
    serialNumber: 'PB67891234',
  },
  {
    id: '4',
    name: 'Cable Machine Multi-Station',
    category: 'Strength',
    brand: 'Life Fitness',
    model: 'G7 Home Gym',
    acquisitionDate: '2022-11-05',
    acquisitionCost: 3200,
    currentValue: 2560,
    status: 'Available',
    condition: 'Good',
    location: 'Strength Training Zone B',
    maxUsers: 2,
    currentUsers: 0,
    maintenanceSchedule: 'Monthly',
    lastMaintenance: '2024-01-05',
    nextMaintenance: '2024-02-05',
    warrantyExpiry: '2025-11-05',
    notes: 'Multi-station cable machine with lat pulldown and low row',
    utilization: 68,
    specifications: {
      weight: 250,
      dimensions: '210 x 165 x 210 cm',
      powerRequirement: 'Manual operation',
      capacity: '150kg weight stack',
    },
    attachments: ['manual.pdf', 'exercise_guide.pdf'],
    qrCode: 'LF-CM-004',
    serialNumber: 'LF45678912',
  },
  {
    id: '5',
    name: 'Rowing Machine',
    category: 'Cardio',
    brand: 'Concept2',
    model: 'Model D',
    acquisitionDate: '2023-05-18',
    acquisitionCost: 1200,
    currentValue: 1080,
    status: 'Available',
    condition: 'Excellent',
    location: 'Cardio Zone B',
    maxUsers: 1,
    currentUsers: 0,
    maintenanceSchedule: 'Monthly',
    lastMaintenance: '2024-01-18',
    nextMaintenance: '2024-02-18',
    warrantyExpiry: '2028-05-18',
    notes: 'Air resistance rowing machine with PM5 monitor',
    utilization: 64,
    specifications: {
      weight: 26,
      dimensions: '244 x 61 x 36 cm',
      powerRequirement: 'Battery powered (2 x D batteries)',
      capacity: '227kg max user weight',
    },
    attachments: ['manual.pdf', 'workout_guide.pdf'],
    qrCode: 'C2-RM-005',
    serialNumber: 'C2123456789',
  },
  {
    id: '6',
    name: 'Kettlebell Set',
    category: 'Functional',
    brand: 'CAP Barbell',
    model: 'Cast Iron Series',
    acquisitionDate: '2022-07-12',
    acquisitionCost: 320,
    currentValue: 256,
    status: 'Available',
    condition: 'Good',
    location: 'Functional Training Area',
    maxUsers: 4,
    currentUsers: 0,
    maintenanceSchedule: 'Quarterly',
    lastMaintenance: '2023-10-12',
    nextMaintenance: '2024-04-12',
    notes: 'Set includes 8kg, 12kg, 16kg, 20kg, 24kg kettlebells',
    utilization: 71,
    specifications: {
      weight: 80,
      dimensions: 'Various sizes',
      capacity: 'Cast iron construction',
    },
    attachments: ['exercise_guide.pdf'],
    qrCode: 'CAP-KB-006',
    serialNumber: 'CAP78912345',
  },
  {
    id: '7',
    name: 'Pull-up/Dip Station',
    category: 'Strength',
    brand: 'Rogue Fitness',
    model: 'Matador Dip Attachment',
    acquisitionDate: '2023-09-22',
    acquisitionCost: 180,
    currentValue: 162,
    status: 'Available',
    condition: 'Excellent',
    location: 'Bodyweight Training Area',
    maxUsers: 1,
    currentUsers: 0,
    maintenanceSchedule: 'Quarterly',
    lastMaintenance: '2023-12-22',
    nextMaintenance: '2024-03-22',
    warrantyExpiry: '2026-09-22',
    notes: 'Portable dip attachment for power racks',
    utilization: 45,
    specifications: {
      weight: 8,
      dimensions: '61 x 61 cm',
      capacity: '180kg max user weight',
    },
    attachments: ['installation_guide.pdf'],
    qrCode: 'RG-PD-007',
    serialNumber: 'RG34567891',
  },
  {
    id: '8',
    name: 'Exercise Bike',
    category: 'Cardio',
    brand: 'Schwinn',
    model: 'IC4 Indoor Cycling Bike',
    acquisitionDate: '2023-04-08',
    acquisitionCost: 900,
    currentValue: 765,
    status: 'Maintenance',
    condition: 'Fair',
    location: 'Cardio Zone A',
    maxUsers: 1,
    currentUsers: 0,
    maintenanceSchedule: 'Monthly',
    lastMaintenance: '2024-01-08',
    nextMaintenance: '2024-01-25',
    warrantyExpiry: '2025-04-08',
    notes: 'Magnetic resistance bike with Bluetooth connectivity - currently in maintenance for belt adjustment',
    utilization: 82,
    specifications: {
      weight: 48,
      dimensions: '122 x 53 x 134 cm',
      powerRequirement: 'AC adapter',
      capacity: '136kg max user weight',
    },
    attachments: ['manual.pdf', 'maintenance_log.pdf'],
    qrCode: 'SW-EB-008',
    serialNumber: 'SW56789123',
  },
]; 